<template>
  <v-dialog
    v-model="isOpenModalDetailApport"
    fullscreen
    transition="slide-x-transition"
    @click:outside="onClose"
  >
    <v-card class="left-vertical-card">
      <div class="d-flex justify-space-between bg-titre">
        <div class="d-flex flex-column align-self-center ml-2">
          <div class="secondary--text align-self-center pl-3 titre-h3 mr-auto">
            Apport du {{ apport.dateApport | date('dd/MM/yyy') }}
          </div>
          <div class="align-self-center texte-gris-fonce pl-3 texte mr-auto">
            Bon n° {{ apport.numeroBon }}
          </div>
        </div>
        <v-btn
          class="align-self-center"
          text
          @click="onClose"
        >
          <v-icon color="secondary">
            mdi-close
          </v-icon>
        </v-btn>
      </div>
      <div class="d-flex justify-space-between ma-5 mt-5">
        <div class="texte-gris-fonce intro align-self-center">
          Poids aux normes
        </div>
        <div class="titre-h4 secondary--text align-self-center">
          {{ apport.poidsAuxNormesEnKg / 1000 | roundNumber(3) }} t
        </div>
      </div>
      <v-divider class="mx-3" />
      <div class="d-flex justify-space-between ma-5 mt-5">
        <div class="texte-gris-fonce intro align-self-center">
          Type de contrat
        </div>
        <div class="titre-h4 secondary--text align-self-center align-end">
          {{ apport.libelleTypeContrat }}
        </div>
      </div>
      <v-divider class="mx-3" />
      <div class="d-flex justify-space-between ma-5 mt-5">
        <div class="texte-gris-fonce intro align-self-center">
          Poids contrat
        </div>
        <div
          v-if="detailMouvement && detailMouvement.contrat && !loadingDetailMouvement"
          class="titre-h4 secondary--text align-self-center"
        >
          {{ detailMouvement.contrat.quantiteCibleEnKg / 1000 | roundNumber(3) }} t
        </div>
      </div>
      <BaseLoader v-if="loadingDetailMouvement" />
      <v-card
        v-else
        class="ma-5 pa-3"
        color="var(--kaki)"
        elevation="0"
      >
        <div class="action secondary--text mb-2">
          <v-icon
            class="mr-2"
            color="secondary"
          >
            mdi-information
          </v-icon>Comment a été valorisé cet apport ?
        </div>
        <div class="texte texte-gris-fonce mb-3">
          Nous avons pris en compte les +/- values de chaque qualité :
        </div>
        <div
          v-if="detailMouvement && detailsQualite.poidsSpecifiqueEnKgParHL"
          class="d-flex justify-space-between"
        >
          <div class="texte texte-gris-fonce w-90">
            PS
          </div>
          <div class="texte texte-gris-fonce w-90">
            {{ detailsQualite.poidsSpecifiqueEnKgParHL | roundNumber(1) }} kh/hl
          </div>
          <div class="w-80">
            <v-chip
              :color="getColorChip(detailsQualite.valorisationPrixPoidsSpecifiqueEnEuroParTonne)"
              label
              small
            >
              <div
                :class="getColorTextChip(detailsQualite.valorisationPrixPoidsSpecifiqueEnEuroParTonne)"
                class="texte"
              >
                {{ getValeurValorisation(detailsQualite.valorisationPrixPoidsSpecifiqueEnEuroParTonne) }} €/t
              </div>
            </v-chip>
          </div>
        </div>
        <v-divider
          v-if="detailMouvement && detailsQualite.tauxHumiditeEnPourcentage"
          class="my-2"
        />
        <div
          v-if="detailMouvement && detailsQualite.tauxHumiditeEnPourcentage"
          class="d-flex justify-space-between"
        >
          <div class="texte texte-gris-fonce w-90">
            Humidité
          </div>
          <div class="texte texte-gris-fonce w-90">
            {{ detailsQualite.tauxHumiditeEnPourcentage | roundNumber(1) }} %
          </div>
          <div class="w-80">
            <v-chip
              :color="getColorChip(detailsQualite.valorisationPrixHumiditeEnEuroParTonne)"
              label
              small
            >
              <div
                :class="getColorTextChip(detailsQualite.valorisationPrixHumiditeEnEuroParTonne)"
                class="texte"
              >
                {{ getValeurValorisation(detailsQualite.valorisationPrixHumiditeEnEuroParTonne) }} €/t
              </div>
            </v-chip>
          </div>
        </div>
        <v-divider
          v-if="detailMouvement && detailsQualite.tauxImpuretesEnPourcentage"
          class="my-2"
        />
        <div
          v-if="detailMouvement && detailsQualite.tauxImpuretesEnPourcentage"
          class="d-flex justify-space-between"
        >
          <div class="texte texte-gris-fonce w-90">
            Impuretés
          </div>
          <div class="texte texte-gris-fonce w-90">
            {{ detailsQualite.tauxImpuretesEnPourcentage | roundNumber(1) }} %
          </div>
          <div class="w-80">
            <v-chip
              :color="getColorChip(detailsQualite.valorisationPrixImpuretesEnEuroParTonne)"
              label
              small
            >
              <div
                :class="getColorTextChip(detailsQualite.valorisationPrixImpuretesEnEuroParTonne)"
                class="texte"
              >
                {{ getValeurValorisation(detailsQualite.valorisationPrixImpuretesEnEuroParTonne) }} €/t
              </div>
            </v-chip>
          </div>
        </div>
        <v-divider
          v-if="detailMouvement && detailsQualite.tauxProteinesEnPourcentage"
          class="my-2"
        />
        <div
          v-if="detailMouvement && detailsQualite.tauxProteinesEnPourcentage"
          class="d-flex justify-space-between"
        >
          <div class="texte texte-gris-fonce w-90">
            Protéines
          </div>
          <div class="texte texte-gris-fonce w-90">
            {{ detailsQualite.tauxProteinesEnPourcentage | roundNumber(1) }} %
          </div>
          <div class="w-80">
            <v-chip
              :color="getColorChip(detailsQualite.valorisationPrixProteinesEnEuroParTonne)"
              label
              small
            >
              <div
                :class="getColorTextChip(detailsQualite.valorisationPrixProteinesEnEuroParTonne)"
                class="texte"
              >
                {{ getValeurValorisation(detailsQualite.valorisationPrixProteinesEnEuroParTonne) }} €/t
              </div>
            </v-chip>
          </div>
        </div>
        <v-divider
          v-if="detailMouvement && detailsQualite.valorisationFlairEnEuroParTonne"
          class="my-2"
        />
        <div
          v-if="detailMouvement && detailsQualite.valorisationFlairEnEuroParTonne"
          class="d-flex justify-space-between"
        >
          <div class="texte texte-gris-fonce">
            Flair
          </div>
          <div class="w-80">
            <v-chip
              :color="getColorChip(detailsQualite.valorisationFlairEnEuroParTonne)"
              label
              small
            >
              <div
                :class="getColorTextChip(detailsQualite.valorisationFlairEnEuroParTonne)"
                class="texte"
              >
                {{ getValeurValorisation(detailsQualite.valorisationFlairEnEuroParTonne) }} €/t
              </div>
            </v-chip>
          </div>
        </div>
        <v-divider
          v-if="detailMouvement && detailsQualite.valorisationInsectesEnEuroParTonne"
          class="my-2"
        />
        <div
          v-if="detailMouvement && detailsQualite.valorisationInsectesEnEuroParTonne"
          class="d-flex justify-space-between"
        >
          <div class="texte texte-gris-fonce w-90">
            Insectes
          </div>
          <div class="w-80">
            <v-chip
              :color="getColorChip(detailsQualite.valorisationInsectesEnEuroParTonne)"
              label
              small
            >
              <div
                :class="getColorTextChip(detailsQualite.valorisationInsectesEnEuroParTonne)"
                class="texte"
              >
                {{ getValeurValorisation(detailsQualite.valorisationInsectesEnEuroParTonne) }} €/t
              </div>
            </v-chip>
          </div>
        </div>
        <v-divider
          v-if="detailMouvement && detailsQualite.valorisationMitadineEnEuroParTonne"
          class="my-2"
        />
        <div
          v-if="detailMouvement && detailsQualite.valorisationMitadineEnEuroParTonne"
          class="d-flex justify-space-between"
        >
          <div class="texte texte-gris-fonce w-90">
            Mitadines
          </div>
          <div class="texte texte-gris-fonce w-90">
            {{ detailsQualite.tauxMitadineEnPourcentage | roundNumber(1) }} %
          </div>
          <div class="w-80">
            <v-chip
              :color="getColorChip(detailsQualite.valorisationMitadineEnEuroParTonne)"
              label
              small
            >
              <div
                :class="getColorTextChip(detailsQualite.valorisationMitadineEnEuroParTonne)"
                class="texte"
              >
                {{ getValeurValorisation(detailsQualite.valorisationMitadineEnEuroParTonne) }} €/t
              </div>
            </v-chip>
          </div>
        </div>
        <v-divider
          v-if="detailMouvement && detailsQualite.valorisationHagbergEnEuroParTonne"
          class="my-2"
        />
        <div
          v-if="detailMouvement && detailsQualite.valorisationHagbergEnEuroParTonne"
          class="d-flex justify-space-between"
        >
          <div class="texte texte-gris-fonce w-90">
            Hagberg
          </div>
          <div class="texte texte-gris-fonce w-90">
            {{ detailsQualite.tauxTempsChuteHagbergEnSeconde | roundNumber(1) }} s
          </div>
          <div class="w-80">
            <v-chip
              :color="getColorChip(detailsQualite.valorisationHagbergEnEuroParTonne)"
              label
              small
            >
              <div
                :class="getColorTextChip(detailsQualite.valorisationHagbergEnEuroParTonne)"
                class="texte"
              >
                {{ getValeurValorisation(detailsQualite.valorisationHagbergEnEuroParTonne) }} €/t
              </div>
            </v-chip>
          </div>
        </div>
        <v-divider
          v-if="detailMouvement && detailsQualite.valorisationDeclassementEnEuroParTonne"
          class="my-2"
        />
        <div
          v-if="detailMouvement && detailsQualite.valorisationDeclassementEnEuroParTonne"
          class="d-flex justify-space-between"
        >
          <div class="texte texte-gris-fonce w100">
            Déclassement
          </div>
          <div class="w-80">
            <v-chip
              :color="getColorChip(detailsQualite.valorisationDeclassementEnEuroParTonne)"
              label
              small
            >
              <div
                :class="getColorTextChip(detailsQualite.valorisationDeclassementEnEuroParTonne)"
                class="texte"
              >
                {{ getValeurValorisation(detailsQualite.valorisationDeclassementEnEuroParTonne) }} €/t
              </div>
            </v-chip>
          </div>
        </div>
        <v-divider
          v-if="detailMouvement && detailsQualite.valorisationFraisNettoyageEnEuroParTonne"
          class="my-2"
        />
        <div
          v-if="detailMouvement && detailsQualite.valorisationFraisNettoyageEnEuroParTonne"
          class="d-flex justify-space-between"
        >
          <div class="texte texte-gris-fonce w100">
            Frais nettoyage
          </div>
          <div class="w-80">
            <v-chip
              :color="getColorChip(detailsQualite.valorisationFraisNettoyageEnEuroParTonne)"
              label
              small
            >
              <div
                :class="getColorTextChip(detailsQualite.valorisationFraisNettoyageEnEuroParTonne)"
                class="texte"
              >
                {{ getValeurValorisation(detailsQualite.valorisationFraisNettoyageEnEuroParTonne) }} €/t
              </div>
            </v-chip>
          </div>
        </div>
        <div class="texte texte-gris-fonce mt-3">
          Soit un impact total de :
        </div>
        <v-chip
          :color="getColorChip(detailsQualite.valorisationTotalEnEuroParTonne)"
          class="mt-2"
          label
          small
        >
          <div
            :class="getColorTextChip(detailsQualite.valorisationTotalEnEuroParTonne)"
            class="texte"
          >
            {{ getValeurValorisation(detailsQualite.valorisationTotalEnEuroParTonne) }} €/t
          </div>
        </v-chip>
      </v-card>

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <div
            :class="$vuetify.breakpoint.mobile ? 'mt-3 d-flex ' : 'ml-4'"
            v-on="on"
          >
            <div
              :class="(!loadingReglementCampagne && hasReglementCampagne) ? 'cursor-pointer' : 'cursor-no-drop'"
              class="d-flex ml-2"
              @click="telechargerPDFReglementCampagne"
            >
              <BaseLoader v-if="loadingReglementCampagne" />
              <v-icon
                :color="(!hasReglementCampagne || loadingReglementCampagne) ? 'grey' : 'primary'"
                class="mr-2"
              >
                mdi-tray-arrow-down
              </v-icon>
              <span
                :class="(!hasReglementCampagne || loadingReglementCampagne) ? 'grey--text' : 'primary--text'"
                class="text-truncate align-self-center"
              >Règlement de campagne (PDF)</span>
            </div>
          </div>
        </template>
        {{ tooltipReglementCampagne }}
      </v-tooltip>
      <div class="ma-5 pb-9">
        <AgrButton
          block
          class="my-3"
          elevation="0"
          large
          @click="onContrat"
        >
          <span class="action text-truncate white--text">
            Voir le contrat
          </span>
        </AgrButton>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import {AgrButton} from '@agrial/ui'
import BaseLoader from '@/components/common/base-loader.vue'
import {round} from 'lodash'
import {mapActions, mapGetters} from 'vuex'

export default {
  name: 'DetailApportModal',
  components: {AgrButton, BaseLoader},
  props: {
    apport: {
      type: Object,
      default: () => {}
    },
    loadingDetailMouvement: {
      type: Boolean,
      default: false
    },
    erreurDetailMouvement: {
      type: Boolean,
      default: false
    },
    isOpenModalDetailApport: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      tooltipReglementCampagne: null,
      hasReglementCampagne: false,
      loadingReglementCampagne: false,
      erreurReglementCampagne: false,
    }
  },

  computed: {
    ...mapGetters({
      reglementCampagne: 'reglementCampagne/reglementCampagne',
      pdfReglementCampagne: 'reglementCampagne/pdfReglementCampagne',
      detailMouvement: 'mouvement/detailMouvement'
    }),
    detailsQualite () {
      return this.detailMouvement.detailsQualite
    },
  },

  created () {
    this.loadReglementCampagne()
  },

  methods: {
    ...mapActions({
      getReglementCampagne: 'reglementCampagne/getReglementCampagne',
      telechargerDocumentPdf: 'reglementCampagne/telechargerDocumentPdf',
      initFiltresContrat: 'filtresContrat/initFiltres'
    }),

    loadReglementCampagne () {
      this.loadingReglementCampagne = true
      this.erreurReglementCampagne = false

      this.getReglementCampagne({anneeRecolte: this.apport.anneeRecolte, codeGraineRs3: this.apport.codeIdaRs3})
        .then(() => {
          this.hasReglementCampagne = !!(this.reglementCampagne && Object.entries(this.reglementCampagne).length > 0)
          this.tooltipReglementCampagne = 'Consultation du document de règlement de campagne'
        })
        .catch(() => {
          this.tooltipReglementCampagne = 'Nous ne parvenons pas à trouver votre document de règlement de campagne.'
          this.hasReglementCampagne = false
          this.erreurReglementCampagne = true
        })
        .finally(() => this.loadingReglementCampagne = false)
    },
    telechargerPDFReglementCampagne () {
      if (this.hasReglementCampagne) {
        this.loadingReglementCampagne = true
        this.erreurReglementCampagne = false

        this.telechargerDocumentPdf(this.reglementCampagne)
          .then(() => {
            const popup = window.open('about:blank', '_blank')
            popup.location = window.URL.createObjectURL(new Blob([this.pdfReglementCampagne], { type: 'application/pdf' }))
          })
          .catch(() => {
            this.erreurReglementCampagne = true
            this.tooltipReglementCampagne = 'Impossible de récupérer le pdf de règlement de campagne'
            this.hasReglementCampagne = false
          })
          .finally(() => this.loadingReglementCampagne = false)
      }
    },
    onClose () {
      this.$emit('close')
    },
    onContrat () {
      const params = {
        resumesContrats: [],
        numeroContrat: this.apport.numeroContratCommercial
      }

      this.initFiltresContrat(params)

      this.$router.push({
        name: 'main.mes-contrats', params: {
          anneeRecolte: this.apport.anneeRecolte,
          codeGraineRs3: this.apport.codeIdaRs3,
          numeroContrat: this.apport.numeroContratCommercial
        }

      })

    },
    getValeurValorisation (value) {
      if (value >= 0) {
        return '+ ' + round(value, 1).toString().replace(/\./g, ',')
      } else {
        return '- ' + round(value * -1, 1).toString().replace(/\./g, ',')
      }
    },
    getColorChip (value) {
      if (value > 0) {
        return '#01713C'
      }
      else if (value < 0) {
        return '#EC6608'
      } else {
        return '#FFFFFF'
      }
    },
    getColorTextChip (value) {
      if (value === 0) {
        return 'secondary--text'
      } else {
        return 'white--text'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.left-vertical-card {
  border-radius: 0 !important;
}

.bg-titre {
  height: 70px;
  background-color: #f1f2f5;
}
.w-90 {
  width: 90px;
}
.w-80 {
  width: 80px;
}
.align-end {
  text-align: end;
}
.cursor-pointer {
  cursor: pointer;
}
.cursor-no-drop {
  cursor: no-drop;
}
</style>
